import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "product-card__benefits",
  "data-eq-part": "product-card__benefits"
}

import Product from '@/classes/Product';
import List from '@/components/List.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCardBenefits',
  props: {
    product: {}
  },
  setup(__props: any) {

const props = __props;

const benefits = computed<string[]>(() => {
  const listOfBenefits = [...props.product.benefits];

  if (props.product.contractTermIsFixed) {
    listOfBenefits.push(`Vertragslaufzeit bis zum ${props.product.contractTermLabel}`);
  } else {
    listOfBenefits.push(`${props.product.contractTermLabel} Vertragslaufzeit`);
  }

  if (props.product.hasPriceGuarantee) {
    const priceGuaranteeInfo = `
      Zu deinem Vorteil sichern wir den reinen Energiepreis
      ${props.product.priceGuaranteeIsFixed ? 'bis zum' : ''}
      ${props.product.priceGuaranteeLabel}
      ab. Die Preissicherheit gilt ab dem voraussichtlichen Lieferbeginn und schützt dich vor
      Marktpreisschwankungen. Die Preissicherheit ist eingeschränkt, da wir gemäß §7 unserer AGB neue oder
      geänderte staatlich veranlasste Abgaben wie z. B. Steuern, die ca ⅔ des Gesamtpreises ausmachen,
      weitergegeben werden.
    `;
    if (props.product.priceGuaranteeIsFixed) {
      listOfBenefits.push([`Preisgarantie bis zum ${props.product.priceGuaranteeLabel}`, priceGuaranteeInfo]);
    } else {
      listOfBenefits.push([`${props.product.priceGuaranteeLabel} Preisgarantie`, priceGuaranteeInfo]);
    }
  }

  return listOfBenefits;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(List, {
      type: "icon",
      icon: "fa-solid fa-check",
      items: benefits.value
    }, null, 8, ["items"])
  ]))
}
}

})